import React, { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';

import { SearchPeopleQueryVariables } from 'api';
import { usePeopleSearch } from 'hooks';
import { IEmptyState, UserCard, EmptyState, Loaders } from 'components';

import Loader from './Loader';

interface IProps {
  emptyStateName: keyof IEmptyState;
  variables: SearchPeopleQueryVariables;
}

const QueryList: FC<IProps> = ({ emptyStateName, variables }) => {
  const { results, isExhausted, isEmpty, isInitialLoad, sentinelRef } = usePeopleSearch(variables);

  if (isEmpty) {
    return <EmptyState name={emptyStateName} />;
  }

  if (isInitialLoad) {
    return <Loader />;
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        {results.map(profile => (
          <UserCard key={profile.id} user={profile} />
        ))}
      </Grid>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

export default QueryList;
